import { gql } from '@apollo/client';

export const CREATE_USER = gql`
mutation($record: CreatePractitionerInput!)
  {user
      {dashboardUser
          {createPractitioner(record: $record)
              {
                  ok,
                  error{
                      message,
                      code
                  },
                  resultId,
                  result{
                      id,
                      email,
                  }                
              }
          }
      }
  }
`;
